module.exports = __webpack_public_path__ + "61088911474ab40150c37f4767a7a94c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/ball-baseball-glove-s.png
// module id = 1962
// module chunks = 0